import { writable } from "svelte/store";
import { call } from "$lib/Api/Api.svelte";

const zorgverlenerTypes = writable([]);

const zorgverlenerTypeStore = {
  subscribe: zorgverlenerTypes.subscribe,
  load: (id) => {
    return call("zorgverlener-types", "query")
      .then((data) => {
        data.sort((a, b) => {
          return a.value < b.value ? -1 : a.value > b.value ? 1 : 0;
        });
        zorgverlenerTypes.set(data);
      })
      .catch((err) => {});
  },
};

export default zorgverlenerTypeStore;
